export var IProductFirstCatNavRequest;
(function (IProductFirstCatNavRequest) {
    let SortBy;
    (function (SortBy) {
        SortBy["FEATURED"] = "FEATURED";
        SortBy["NEWEST"] = "NEWEST";
    })(SortBy = IProductFirstCatNavRequest.SortBy || (IProductFirstCatNavRequest.SortBy = {}));
    let Placement;
    (function (Placement) {
        /**
         * Obeys filter keys, and returns filter sections (default if not specified).
         */
        Placement["MAIN_GRID"] = "MAIN_GRID";
        /**
         * Skips building filter sections and limit brands that were first activated within last 30 days
         * @deprecated
         */
        Placement["NEW_BRAND_CAROUSEL"] = "NEW_BRAND_CAROUSEL";
    })(Placement = IProductFirstCatNavRequest.Placement || (IProductFirstCatNavRequest.Placement = {}));
    /**
     * Return an instance of IProductFirstCatNavRequest with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IProductFirstCatNavRequest.build = (partial) => (Object.assign({ filter_keys: [], previous_filter_keys: [], initial_request_exposed_visual_filter_option_keys: [], filters_to_include: [] }, (partial !== null && partial !== void 0 ? partial : {})));
})(IProductFirstCatNavRequest || (IProductFirstCatNavRequest = {}));
